function login(email, password) {  
  var data = {
    'customer[email]': email,
    'customer[password]': password,
    form_type: 'customer_login',
    utf8: '✓'
  };
  
  var promise = $.ajax({
    url: '/account/login',
    method: 'post',
    data: data,
    dataType: 'html',
    async: true
  });
  return promise;
}

function recoverPassword(email) {
  var data = {
    'email': email,
    form_type: 'recover_customer_password',
    utf8: '✓'
  };

  var promise = $.ajax({
    url: '/account/recover',
    method: 'post',
    data: data,
    dataType: 'html',
    async: true
  });
  return promise;
}

$(document).ready(function() {
  $("body").on("click", "#login-btn", function() {
    $(".login-error").hide();
    $("#login-btn").val("Please wait");
    login($("#customer_email").val(), $("#customer_password").val()).done(function (html) {  
      setTimeout(function() {
        $.get("/account #login_account", function(htmlNew) {
          if (htmlNew.indexOf('Your Account') == -1) {
           
            $(".login-error").show();
            $("#login-btn").val("Login");
          } else {
            window.location.reload();
          }
        });
      }, 1000);
    });
  });
  $("body").on("click", ".forgot-password", function() {
    $("#login").fadeOut(500, function() {
      $("#recover-password").fadeIn(500);
    });
  });
  $("body").on("click", "#displayLogin", function() {
    $("#recover-password").fadeOut(500, function() {
      $("#login").fadeIn(500);
    });
  });
  $("body").on("click", "#forgotpass", function() {
    $(".login-error").hide();
    $("#forgotpass").val("Please wait");
    recoverPassword($("#recover-email").val()).done(function (html) {  
      $("#forgotpass").val("Submit");
      $(".show-msg").show();
      $(".default-text").hide();
      setTimeout(function() {
        $("#displayLogin").click();
        $(".show-msg").hide();
        $(".default-text").show();
      }, 3000);
    });
  });
  $("body").on("click", ".close-account-popup", function() {
    $("#customer-login-popup").fadeOut(500, function() {
      $("#loginDiv-overlay").fadeOut(500);
    });
  });
});